<i18n src="../../locales/lang.json"></i18n>



<template>
  <div style="position:relative">
    <div class="row">
      <div class="col pr-5 pr-0" id="test" style="z-index:3">
        <div ref="buttonContainer" class="pl-2 pl-md-0 pb-2" id="buttonContainer">
          <div class="dropdown dropright" style="margin:auto;z-index:1000;float:left;margin-right:0px;" id="initialButton">
            <button v-if="readonly == false" type="button" @click="initialLoad()" class="newplus-button btn p-0 m-0" style="border: 0; background-color: initial !important; box-shadow:none !important;" data-toggle="dropdown" data-display="static" aria-haspopup="true" aria-expanded="false">
              <img src="/Images/Filter_Black_100x100px.png" class="button-icon" />
            </button>
            <button v-if="readonly == true" type="button" class="newplus-button btn p-0 m-0" style="border: 0; background-color: initial !important; box-shadow:none !important;" data-display="static">
              <img src="/Images/Filter_Black_100x100px.png" class="button-icon" />
            </button>

            <div class="skinnedmenu dropdown-menu" id="additemsmenu">

              <div class="dropdown-submenu" v-show="hideMySchedule===false">
                <a href="#" class="dropdown-item dropdown-toggle">{{$t('my_schedule')}}</a>
                <div class="dropdown-menu mobile-submenu" style="position: relative;">
                  <a @click="addScheduleFilterButton('today')" class="dropdown-item">{{$t('today')}}</a>
                  <a @click="addScheduleFilterButton('yesterday')" class="dropdown-item">{{$t('yesterday')}}</a>
                  <a @click="addScheduleFilterButton('tomorrow')" class="dropdown-item">{{$t('tomorrow')}}</a>
                  <a @click="addScheduleFilterButton('thisweek')" class="dropdown-item">{{$t('thisweek')}}</a>
                  <a @click="addScheduleFilterButton('nextweek')" class="dropdown-item">{{$t('nextweek')}}</a>
                </div>
              </div>
              <div class="dropdown-submenu" v-show="tags.length>0 && this.$store.getUserPermissionLevel() > 2">
                <a href="#" class="dropdown-item dropdown-toggle" style="">{{$t('tags')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                    <input type="text" class="form-control form-control" v-model="tagFilter" @input="filterTags" placeholder="filter">
                    <div class="form-control-feedback form-control-feedback">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                  <a v-bind:style="getdisplay(menuItem)" v-on:click.prevent="addFilterButton('tag',menuItem.text, menuItem.text)" class="dropdown-item" v-for="menuItem in tags">{{ menuItem.text }}</a>
                </div>
              </div>
              <div class="dropdown-submenu" v-show="locations.length>0 && this.$store.getUserPermissionLevel() > 2">
                <a href="#" class="dropdown-item dropdown-toggle" style="">{{ $store.translate('location')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                    <input type="text" class="form-control form-control" v-model="locationFilter" @input="filterLocations" placeholder="filter">
                    <div class="form-control-feedback form-control-feedback">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                  <a v-bind:style="getdisplay(menuItem)" v-on:click.prevent="addFilterButton('location',menuItem.id, menuItem.text, menuItem.menu)" class="dropdown-item" v-for="menuItem in locations">{{ menuItem.text }}</a>
                </div>
              </div>
              <div class="dropdown-submenu" v-show="reports.length>0 && this.$store.getUserPermissionLevel() > 2">
                <a href="#" class="dropdown-item dropdown-toggle" style="">{{ $store.translate('report')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                    <input type="text" class="form-control form-control" v-model="reportFilter" @input="filterReports" placeholder="filter">
                    <div class="form-control-feedback form-control-feedback">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                  <a v-bind:style="getdisplay(menuItem)" v-on:click.prevent="addFilterButton('report',menuItem.id, menuItem.text, menuItem.menu)" class="dropdown-item" v-for="menuItem in reports">{{ menuItem.text }}</a>
                </div>
              </div>
              <div class="dropdown-submenu" v-show="shifts.length>0 && this.$store.getUserPermissionLevel() > 2">
                <a href="#" class="dropdown-item dropdown-toggle" style="">{{$store.translate('shift')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                    <input type="text" class="form-control form-control" v-model="shiftFilter" @input="filterShifts" placeholder="filter">
                    <div class="form-control-feedback form-control-feedback">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                  <a v-bind:style="getdisplay(menuItem)" v-on:click.prevent="addShiftButton('siteshift',menuItem.id, menuItem.text, menuItem.shiftTypeId)" class="dropdown-item" v-for="menuItem in shifts">{{ menuItem.text }}</a>
                </div>
              </div>
              <div class="dropdown-submenu" v-show="teams.length>0 && this.$store.getUserPermissionLevel() > 2">
                <a href="#" style="" class="dropdown-item dropdown-toggle">{{$store.translate('team')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position:relative;">
                  <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                    <input type="text" class="form-control form-control" v-model="teamFilter" @input="filterTeams" placeholder="filter">
                    <div class="form-control-feedback form-control-feedback">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                  <a v-bind:style="getdisplay(menuItem)" @click="addFilterButton('team',menuItem.id, menuItem.text)" class="dropdown-item" v-for="menuItem in teams">{{ menuItem.text }}</a>
                </div>
              </div>

              <div class="dropdown-submenu" v-show="projects.length>0 && this.$store.getUserPermissionLevel() > 2">
                <a href="#" style="" class="dropdown-item dropdown-toggle">{{$store.translate('project')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position:relative;">
                  <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                    <input type="text" class="form-control form-control" v-model="projectFilter" @input="filterProjects" placeholder="filter">
                    <div class="form-control-feedback form-control-feedback">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                  <a v-bind:style="getdisplay(menuItem)" @click="addFilterButton('project',menuItem.id, menuItem.text)" class="dropdown-item" v-for="menuItem in projects">{{ menuItem.text }}</a>
                </div>
              </div>

              <div class="dropdown-submenu" v-show="this.$store.getUserPermissionLevel() > 2">
                <a href="#" class="dropdown-item dropdown-toggle" @click="loadUsers">{{$t('user')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                    <input type="text" class="form-control form-control" v-model="userFilter" @input="filterUsers" placeholder="filter">
                    <div class="form-control-feedback form-control-feedback">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                  <a v-bind:style="getdisplay(menuItem)" @click="addFilterButton('user',menuItem.id, menuItem.text)" class="dropdown-item" v-for="menuItem in users">{{ menuItem.text }}</a>
                </div>
              </div>
              <div class="dropdown-submenu">
                <a href="#" class="dropdown-item  dropdown-toggle">{{$t('status')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <a @click="addStatusFilterButton('created')" class="dropdown-item">{{$t('created')}}</a>

                  <a @click="addStatusFilterButton('lessreadythan')" class="dropdown-item">{{$t('lessreadythan')}}</a>
                  <a @click="addStatusFilterButton('done')" class="dropdown-item">{{$t('done')}}</a>
                  <a @click="addStatusFilterButton('notstatus')" class="dropdown-item">{{$t('not_done')}}</a>
                  <a @click="addStatusFilterButton('notime')" class="dropdown-item">{{$t('status_notime')}}</a>
                  <a @click="addStatusFilterButton('notable')" class="dropdown-item">{{$t('status_notable')}}</a>
                  <a @click="addStatusFilterButton('missing_information')" class="dropdown-item">{{$t('status_missing_information')}}</a>
                  <a @click="addStatusFilterButton('closed')" class="dropdown-item">{{$t('closed')}}</a>
                </div>
              </div>
              <div class="dropdown-submenu" v-show="this.$store.getUserPermissionLevel() > 2">
                <a href="#" class="dropdown-item  dropdown-toggle">{{$t('priority')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <a @click="addPriorityFilterButton('low')" class="dropdown-item">{{$t('priority_low')}}</a>
                  <a @click="addPriorityFilterButton('medium')" class="dropdown-item">{{$t('priority_medium')}}</a>
                  <a @click="addPriorityFilterButton('high')" class="dropdown-item">{{$t('priority_high')}}</a>
                </div>
              </div>
              <div class="dropdown-submenu">
                <a href="#" class="dropdown-item  dropdown-toggle">{{$t('date')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <a @click="addDateFilterButton('today')" class="dropdown-item">{{$t('today')}}</a>
                  <a @click="addDateFilterButton('tomorrow')" class="dropdown-item">{{$t('tomorrow')}}</a>
                  <a @click="addDateFilterButton('yesterday')" class="dropdown-item">{{$t('yesterday')}}</a>

                  <!--
      <div class="dropdown-item" style="position:relative;display:inline-table">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12"><input-inline-daterange @changed="addAnyDate"></input-inline-daterange></div>
          </div>
          <div class="row">
            <div class="col-12 content-inner"></div>
          </div>
        </div>
      </div>-->
                  <a @click="addDateFilterButton('lastweek')" class="dropdown-item">{{$t('lastweek')}}</a>
                  <a @click="addDateFilterButton('last7days')" class="dropdown-item">{{$t('last7days')}}</a>
                  <a @click="addDateFilterButton('thisweek')" class="dropdown-item">{{$t('thisweek')}}</a>
                  <a @click="addDateFilterButton('nextweek')" class="dropdown-item">{{$t('nextweek')}}</a>
                  <a @click="addDateFilterButton('lastmonth')" class="dropdown-item">{{$t('lastmonth')}}</a>
                  <a @click="addDateFilterButton('thismonth')" class="dropdown-item">{{$t('thismonth')}}</a>
                  <a @click="addDateFilterButton('nextmonth')" class="dropdown-item">{{$t('nextmonth')}}</a>
                  <a @click="openDate" class="dropdown-item">{{$t('custom_date')}}</a>
                </div>
              </div>


              <div class="dropdown-submenu" v-show="this.$store.getUserPermissionLevel() > 2">
                <a href="#" class="dropdown-item  dropdown-toggle">{{$t('weekday')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <a @click="addFilterButton('weekday','2', $t('monday'))" class="dropdown-item">{{$t('monday')}}</a>
                  <a @click="addFilterButton('weekday','3', $t('tuesday'))" class="dropdown-item">{{$t('tuesday')}}</a>
                  <a @click="addFilterButton('weekday','4', $t('wednesday'))" class="dropdown-item">{{$t('wednesday')}}</a>
                  <a @click="addFilterButton('weekday','5', $t('thursday'))" class="dropdown-item">{{$t('thursday')}}</a>
                  <a @click="addFilterButton('weekday','6', $t('friday'))" class="dropdown-item">{{$t('friday')}}</a>
                  <a @click="addFilterButton('weekday','7', $t('saturday'))" class="dropdown-item">{{$t('saturday')}}</a>
                  <a @click="addFilterButton('weekday','1', $t('sunday'))" class="dropdown-item">{{$t('sunday')}}</a>
                </div>
              </div>




              <div class="dropdown-submenu" v-show="organisations.length>0 && this.$store.getUserPermissionLevel() > 2">

                <a href="#" class="dropdown-item dropdown-toggle">{{$t('organisation')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                    <input type="text" class="form-control form-control" v-model="organisationFilter" @input="filterOrganisations" placeholder="filter">
                    <div class="form-control-feedback form-control-feedback">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                  <a v-bind:style="getdisplay(menuItem)" @click="addFilterButton('organisation',menuItem.id, menuItem.text)" class="dropdown-item" v-for="menuItem in organisations">{{ menuItem.text }}</a>
                </div>
              </div>

              <div class="dropdown-submenu" v-show="this.$store.getUserPermissionLevel() > 4">
                <a href="#" class="dropdown-item dropdown-toggle" style="" @click="loadProcedures">{{$store.translate('template')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                    <input type="text" class="form-control form-control" v-model="procedureFilter" @input="filterProcedures" placeholder="filter">
                    <div class="form-control-feedback form-control-feedback">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                  <a v-bind:style="getdisplay(menuItem)" v-on:click.prevent="addFilterButton('procedure',menuItem.id, menuItem.text)" class="dropdown-item" v-for="menuItem in procedures">{{ menuItem.formattedName }}</a>
                </div>
              </div>

              <div class="dropdown-submenu" v-show="this.$store.getUserPermissionLevel() > 4">
                <a href="#" class="dropdown-item dropdown-toggle" style="" @click="loadCategories">{{$t('category')}}</a>
                <div class="skinnedmenu dropdown-menu mobile-submenu" style="position: relative;">
                  <div class="form-group form-group-feedback form-group-feedback-left mx-2 my-0">
                    <input type="text" class="form-control form-control" v-model="categoryFilter" @input="filterCategories" placeholder="filter">
                    <div class="form-control-feedback form-control-feedback">
                      <i class="icon-search4"></i>
                    </div>
                  </div>
                  <a v-bind:style="getdisplay(menuItem)" v-on:click.prevent="addFilterButton('category',menuItem.id, menuItem.text)" class="dropdown-item" v-for="menuItem in categories">{{ menuItem.text }}</a>
                </div>
              </div>
              <!--
  <div class="" v-if="hideMyFilter===false && this.$store.getUserPermissionLevel() > 2">
    <a href="#" class="dropdown-item" style="" @click="saveInBrowser('getfromcookie')">{{$t('my_filter')}}</a>
  </div>
  <div class="" v-if="hideSaveFilter===false && this.$store.getUserPermissionLevel() > 2">
    <a href="#" class="dropdown-item" style="" @click="saveInBrowser('savecookie')">{{$t('save_filter_inbrowser')}}</a>
  </div>
    -->
            </div>
          </div>
        </div>
      </div>

    </div>
    <div v-show="configurators.length > 0" class="row mt-3">
      <div class="col">
        <div id="childComponentContainer" ref="childComponentContainer"></div>
      </div>
    </div>
    <modal-default ref="dateEditor" :onsave="addAnyDate" v-bind:title="$t('date')">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            {{$t('start_date')}}: <input-inline-date @changed="setStartDate"></input-inline-date>
          </div>
          <div class="col-12 mt-2">
            {{$t('end_date')}}: <input-inline-date @changed="setEndDate"></input-inline-date>
          </div>
        </div>
      </div>
    </modal-default>
  </div>




</template>

<script>

  var activated = false;

  import FilterButton from './filter-button.vue'
  import ConfigUser from './configurators/config-user.vue'
  import ConfigContact from './configurators/config-contact.vue'
  import ConfigTeam from './configurators/config-team.vue'
  import ConfigPriority from './configurators/config-priority.vue'
  import ConfigLocation from './configurators/config-location.vue'
  import ConfigDate from './configurators/config-date.vue'
  import ConfigOrganisation from './configurators/config-organisation.vue'

  import DisplayUser from './displayers/display-user.vue'
  import DisplayUserTaskstatus from './displayers/display-user-taskstatus.vue'
  import DisplayUserTime from './displayers/display-user-time.vue'

  import DisplayContact from './displayers/display-contact.vue'
  import DisplayTeam from './displayers/display-team.vue'
  import DisplayTeamWorkload from './displayers/display-team-workload.vue'
  import DisplayTeamTaskstatus from './displayers/display-team-taskstatus.vue'
  import DisplayTeamTime from './displayers/display-team-time.vue'
  import DisplayPriority from './displayers/display-priority.vue'
  import DisplayLocation from './displayers/display-location.vue'
  import DisplayDate from './displayers/display-date.vue'
  import DisplayOrganisation from './displayers/display-organisation.vue'
  import moment from 'moment'

  var user = "";
  var configurators = [];
  var buttons = [];
  var displayers = [];
  var locations = [];
  var shifts = [];
  var projects = [];
  var tags = [];
  var users = [];
  var teams = [];
  var organisations = [];
  var procedures = [];
  var categories = [];
  var reports = [];
  var locationFilter = "";
  var reportFilter = "";
  var shiftFilter = "";
  var projectFilter = "";
  var tagFilter = "";
  var userFilter = "";
  var teamFilter = "";
  var organisationFilter = "";
  var procedureFilter = "";
  var categoryFilter = "";

  export default {
    name: "filter-container",
    components: {
      FilterButton,
      ConfigUser,
      ConfigTeam,
      ConfigPriority,
      ConfigLocation,
      ConfigDate,
      ConfigOrganisation,
      ConfigContact,

      DisplayUser,
      DisplayContact,
      DisplayTeam,
      DisplayTeamWorkload,
      DisplayTeamTaskstatus,
      DisplayTeamTime,
      DisplayPriority,
      DisplayLocation,
      DisplayDate,
      DisplayOrganisation,
    },
    props: {
      enableedit: {
        required: false,
        type: String,
        default: "false"
      },
      user: {
        type: String,
        default: ""
      },
      defaultdisplay: {
        type: Number,
        default: 9
      },
      hideMyFilter: {
        required: false,
        type: Boolean,
        default: false
      },
      hideSaveFilter: {
        required: false,
        type: Boolean,
        default: false
      },
      hideMySchedule: {
        required: false,
        type: Boolean,
        default: false
      },
      allowmultiplesamefilter: {
        required: false,
        type: Boolean,
        default: true
      },
      readonly: {
        required: false,
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        startDate: new Date(),
        endDate: new Date(),
        activated,
        configurators,
        buttons: [],
        displayers,
        locations,
        reports,
        shifts,
        projects,
        tags,
        procedures,
        categories,
        users,
        teams,
        organisations,

        locationFilter,
        reportFilter,
        tagFilter,
        userFilter,
        teamFilter,
        projectFilter,
        organisationFilter,
        isloaded: false
      };
    },

    methods: {
      setStartDate(date) {
        this.startDate = date;
      },
      setEndDate(date) {
        this.endDate = date;
      },
      openDate() {
        this.$refs.dateEditor.open();
      },
      addAnyDate() {
        var startDate = moment(this.startDate);
        var endDate = moment(this.endDate);
        
        startDate = startDate.endOf('day');
        endDate = endDate.endOf('day');
        var cssIcon = null;
        var abbreviation = null;
        var text = startDate.format('D') + " " + startDate.format('MMM') + "-" + endDate.format('D') + " " + endDate.format('MMM');

        var data = startDate.format('YYYY-MM-DD') + "," + endDate.subtract(1, 'days').format('YYYY-MM-DD');

        var buttonData =
        {
          color: "rgba(122, 176, 197, 0.8)",
          customstyle: "background-color:rgba(122,176,197,0.8)",
          customclass: "",
          abbreviation: abbreviation,
          data: data,
          text: text,
          icon: null,
          cssIcon: cssIcon,
          parentguid: null,
          guid: null,
        };

        this.addButton('date', buttonData);
      },
      initialLoad() {

        if (this.isloaded == false) {
          this.loadLocations();
          this.loadTeams();
          this.loadOrganisations();
          this.loadtags();
          this.loadShifts();
          this.loadProjects();
          this.loadReports();
          this.isloaded = true;
        }
      },
      shortenName(name) {
        var ret = name;
        if (name.length > 60)
          ret = name.substring(0, 60) + "...";
        return ret;
      },
      toggleActivation() {
        this.activated = !this.activated
      },
      handleRefresh(val) {
        this.$forceUpdate();
      }
      ,
      addConfigurator(type) {
        var ComponentClass = null;
        if (type == "user") {
          ComponentClass = Vue.extend(ConfigUser);
        }
        else if (type == "contact") {
          ComponentClass = Vue.extend(ConfigContact);
        }
        else if (type == "location") {
          ComponentClass = Vue.extend(ConfigLocation);
        }
        else if (type == "team") {
          ComponentClass = Vue.extend(ConfigTeam);
        }
        else if (type == "priority") {
          ComponentClass = Vue.extend(ConfigPriority);
        }
        else if (type == "date") {
          ComponentClass = Vue.extend(ConfigDate);
        }
        else if (type == "organisation") {
          ComponentClass = Vue.extend(ConfigOrganisation);
        }
        if (!this.hasElementOfType(this.configurators, type)) {
          //var instance = new ComponentClass({ propsData: { type: type } })
          if (type == "organisation") {
            var instance = new ComponentClass({ propsData: { type: type, user: this.user } })
          }
          else {
            var instance = new ComponentClass({ propsData: { type: type } })
          }
          instance.$mount();
          instance.$on('remove', this.removeItem);
          instance.$on('remove', function (id) {
            instance.$el.remove();
          });
          instance.$on('addFilter', this.addButton);
          this.configurators.push({ id: instance.$el.id, type: type });
          this.$refs.childComponentContainer.appendChild(instance.$el);
        }
      },
      removeItem(id) {
        for (var i = 0; i < this.configurators.length; i++) {
          if (this.configurators[i].id == id) {
            this.configurators.splice(i, 1);
          }
        }
        this.$emit('change');
      },
      removeDisplayer(id) {
        for (var i = 0; i < this.displayers.length; i++) {
          if (this.displayers[i].id == id) {
            this.displayers.splice(i, 1);
          }
        }
      },
      disableFilter(id, activated) {
        for (var i = 0; i < this.buttons.length; i++) {
          if (this.buttons[i].id == id) {
            this.buttons[i].config.disabled = activated;
            this.$emit('change');
            vm.$root.$emit('doFilterSearch');
          }
        }
      },
      focusFilter(id, focused, guid, parentguid) {
        if (focused == false) {
          // Go through and activate all
          for (var i = 0; i < this.buttons.length; i++) {
            this.buttons[i].config.disabled = false; // disable all else
            this.buttons[i].config.mute = false;
            this.buttons[i].config.focused = false
          }
        }
        else {
          for (var i = 0; i < this.buttons.length; i++) {
            if (this.buttons[i].config.guid == guid) {  // this filter was clicked
              this.buttons[i].config.disabled = false;
              this.buttons[i].config.mute = false;
              this.buttons[i].config.focused = true
            }
            else if (this.buttons[i].config.guid == parentguid) { // A parent filter
              this.buttons[i].config.disabled = false;
              this.buttons[i].config.mute = false;
              this.buttons[i].config.focused = true
            }
            else if (this.buttons[i].config.parentguid == guid) { // A child filter
              this.buttons[i].config.disabled = false;
              this.buttons[i].config.mute = false;
              this.buttons[i].config.focused = true
            }
            else {
              if (this.buttons[i].config.type == "siteshift" || this.buttons[i].config.type == "location") {
                this.buttons[i].config.disabled = true; // disable all else
                this.buttons[i].config.mute = true;
                this.buttons[i].config.focused = false
              }
              else {
                this.buttons[i].config.focused = true;
              }
            }
          }
        }

        vm.$root.$emit('render_filter');
        vm.$root.$emit('doFilterSearch');
      },

      addDisplayer(type, config, command) {
        var ComponentClass = null;

        if (command != null) {

          if (type == 'team') {
            if (command == 'allusers') {
              this.loadTeamUsers(config.data);
              return;
            }
            else if (command == 'teamtaskstatus') {
              ComponentClass = Vue.extend(DisplayTeamTaskstatus);
            }
            else if (command == 'teamtime') {
              ComponentClass = Vue.extend(DisplayTeamTime);
            }
            else if (command == 'teamworkload') {
              ComponentClass = Vue.extend(DisplayTeamWorkload);
            }
            else if (command == 'manageteam') {
              ComponentClass = Vue.extend(DisplayTeam);
            }
          }
          else if (type == 'user') {
            if (command == 'usertaskstatus') {
              ComponentClass = Vue.extend(DisplayUserTaskstatus);
            }
            else if (command == 'usertime') {
              ComponentClass = Vue.extend(DisplayUserTime);
            }
            else {
              ComponentClass = Vue.extend(DisplayUser);
            }
          }

          else {
            return;
          }
        }
        else {
          if (type == "user") {
            ComponentClass = Vue.extend(DisplayUser);
          }
          else if (type == "contact") {
            ComponentClass = Vue.extend(DisplayContact);
          }
          //else if (type == "location") {
          //  ComponentClass = Vue.extend(DisplayLocation);
          //}
          else if (type == "team") {
            ComponentClass = Vue.extend(DisplayTeam);
          }
          else if (type == "priority") {
            ComponentClass = Vue.extend(DisplayPriority);
          }
          //else if (type == "date") {
          //  ComponentClass = Vue.extend(DisplayDate);
          //}
          else if (type == "organisation") {
            ComponentClass = Vue.extend(DisplayOrganisation);
          }
        }

        //if (!this.hasElementOfType(this.displayers, type)) {
        var instance = new ComponentClass({ propsData: { type: type } })
        instance.setConfig(config);
        instance.$mount();
        instance.$on('remove', this.removeDisplayer);
        instance.$on('remove', function (id) {
          instance.$el.remove();
        });

        instance.$on('addFilter', this.addButton);
        this.displayers.push({ id: instance.$el.id, type: type });
        this.$refs.childComponentContainer.appendChild(instance.$el);
        //}

        if (typeof (instance.rendered) != "undefined") {
          instance.rendered();
        }


      },
      removeButton(id) {
        for (var i = 0; i < this.buttons.length; i++) {
          if (this.buttons[i].id == id) {
            this.buttons.splice(i, 1);
            //alert('doSearch14')
            //vm.$root.$emit('doFilterSearch');
          }
        }
        this.$emit('change');
      },

      addButton(type, config, dosearch) {

        var ComponentClass = Vue.extend(FilterButton)
        var instance = new ComponentClass({
          propsData: {
            type: type,
            readonly: this.readonly,
            config: config
          }
        })

        //instance.config = config;
        instance.$mount();
        instance.$on('remove', this.removeButton);

        instance.$on('remove', function (id) {
          instance.$el.remove();
          //alert('doSearch15')
          vm.$root.$emit('doFilterSearch');
        });
        instance.$on('activate', this.addDisplayer);
        //instance.$on('disableFilter', this.disableFilter);
        instance.$on('focusFilter', this.focusFilter);


        if (this.allowmultiplesamefilter) {
          this.$refs.buttonContainer.appendChild(instance.$el);
          var length = this.buttons.length;
          for (var i = 0; i < length; i++) {
            var btn = this.buttons[i];
            if (btn !== undefined && btn !== null && btn.type === "date" && type === "date") {
              $('#' + btn.id).remove();
              this.removeButton(btn.id);
            }
          }
          this.buttons.push({ id: instance.$el.id, type: type, config: config, readonly: this.readonly });
        }
        else {
          var btns = this.buttons.filter(n => n.type === type);
          if (btns.length === 0) {
            this.$refs.buttonContainer.appendChild(instance.$el);
            this.buttons.push({ id: instance.$el.id, type: type, config: config, readonly: this.readonly });
          }

        }

        if (dosearch == null) {
          //alert('doSearch16')
          vm.$root.$emit('doFilterSearch');
        }

        App.initComponents();
        this.$emit('change');
      },
      saveInBrowser(action) {
        var obj = { action: action };
        var data = JSON.stringify(obj);
        //alert('doSearch17')
        vm.$root.$emit('doFilterSearch', data);
      },
      hasElementOfType(array, type) {
        var hasElementOfType = false;
        for (var i = 0; i < array.length; i++) {
          if (array[i].type == type) {
            hasElementOfType = true;
          }
        }
        return hasElementOfType;
      },
      getCurrentFilter() {
        return this.buttons;
      },
      clearFilters() {

        var children = $('#buttonContainer').children()
        for (var i = 1; i < children.length; i++) {
          children[i].remove()
        }
        this.buttons = [];
      },
      async loadLocations() {
        try {
          this.items = [];
          this.$http.get('/api/Locations/v1?').then(async response => {
            this.locations = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.locationname.toLowerCase();
                var y = b.locationname.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            for (var i = 0; i < response.data.length; i++) {
              var loc = response.data[i];
              if (loc.ParentId === null) {


                var childLocs = response.data.filter(n => n.ParentId == loc.locationid);
                var parentIds = loc.locationid;

                childLocs.forEach(subloc => {
                  parentIds = parentIds + ',' + subloc.locationid;
                });

                var childMenus = [];
                if (childLocs.length > 0) {
                  childMenus.push({
                    command: "location",
                    data: parentIds,
                    text: loc.locationname,
                  })
                }

                // Get the child items
                childLocs.forEach(subloc => {
                  childMenus.push({
                    command: "location",
                    data: subloc.locationid,
                    text: subloc.locationname,
                    customclass: "pl-4",
                  })
                });




                var item = { id: parentIds, text: loc.locationname, display: true };
                item.menu = childMenus;

                this.locations.push(item)

                childLocs.forEach(subloc => {
                  subloc.locationname = loc.locationname + ' > ' + subloc.locationname;
                  this.locations.push({ id: subloc.locationid, text: subloc.locationname, display: true })
                });
              }
            }
            this.filterLocations();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async loadReports() {
        try {
          this.items = [];
          this.$http.get('/api/Reports/v1/Site/Schedules').then(async response => {
            this.reports = [];

            for (var i = 0; i < response.data.length; i++) {
              this.reports.push({ id: response.data[i].Id, text: response.data[i].ReportName, display: true })
            }
            this.filterReports();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async loadShifts() {
        try {
          this.items = [];
          this.$http.get('/api/Admin/v1/SiteShifts').then(async response => {
            this.shifts = [];

            //if (response.data !== null && response.data.length > 0) {
            //  response.data = response.data.sort(function (a, b) {
            //    var x = a.Name.toLowerCase();
            //    var y = b.Name.toLowerCase();
            //    return x < y ? -1 : x > y ? 1 : 0;
            //  });
            //}

            for (var i = 0; i < response.data.length; i++) {
              this.shifts.push({ id: response.data[i].SiteShiftId, text: response.data[i].Name, display: true, shiftTypeId: response.data[i].ShiftTypeId })
            }
            this.filterShifts();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async loadProjects() {
        try {
          this.items = [];
          this.$http.get('/api/Projects/v1').then(async response => {
            this.projects = [];

            //if (response.data !== null && response.data.length > 0) {
            //  response.data = response.data.sort(function (a, b) {
            //    var x = a.Name.toLowerCase();
            //    var y = b.Name.toLowerCase();
            //    return x < y ? -1 : x > y ? 1 : 0;
            //  });
            //}

            for (var i = 0; i < response.data.length; i++) {
              this.projects.push({ id: response.data[i].ProjectId, text: response.data[i].Name, display: true, shiftTypeId: response.data[i].ShiftTypeId })
            }
            this.filterProjects();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async loadtags() {
        try {
          this.items = [];
          this.$http.get('/api/Procedure/v1/GetSiteTags').then(async response => {
            this.tags = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.name.toLowerCase();
                var y = b.name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            for (var i = 0; i < response.data.length; i++) {
              this.tags.push({ id: response.data[i].id, text: response.data[i].name, display: true })
            }
            this.filterTags();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async loadUsers() {
        try {
          this.$http.get('/api/Users/v1').then(async response => {
            this.users = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            for (var i = 0; i < response.data.length; i++) {
              this.users.push({
                id: response.data[i].UserName, text: response.data[i].Name,
                email: response.data[i].Email, display: true
              });
            }
            this.filterUsers();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async loadTeams() {
        try {
          this.$http.get('/api/Teams/v1?').then(async response => {
            this.teams = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            for (var i = 0; i < response.data.length; i++) {
              this.teams.push({ id: response.data[i].Id, text: response.data[i].Name, display: true })
            }
            this.filterTeams();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async loadOrganisations() {
        try {
          this.$http.get('/api/Organization/v1/user?user=' + this.user).then(async response => {
            this.organisations = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.Organization.toLowerCase();
                var y = b.Organization.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            if (response.data.length > 0) {
              for (var i = 0; i < response.data.length; i++) {
                this.organisations.push({ id: response.data[i].Organisationid, text: response.data[i].Organization, display: true })
              }
            } else {
              this.loadAllOrganisations()
            }
            this.filterOrganisations();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },

      async loadAllOrganisations() {
        try {
          this.$http.get('/api/Organizations/v1?').then(async response => {
            this.organisations = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.Organization.toLowerCase();
                var y = b.Organization.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            for (var i = 0; i < response.data.length; i++) {
              this.organisations.push({ id: response.data[i].Organisationid, text: response.data[i].Organization, display: true })
            }
            this.filterOrganisations();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },

      async loadProcedures() {
        try {
          this.$http.get('/api/Procedures/v1/GetProcedures?').then(async response => {
            this.procedures = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            for (var i = 0; i < response.data.length; i++) {
              this.procedures.push({ id: response.data[i].Id, text: response.data[i].Name, formattedName: this.shortenName(response.data[i].Name), display: true })
            }
            this.filterProcedures()
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async loadCategories() {
        try {
          this.$http.get('/api/Procedures/v1/GetProcedureCategories?').then(async response => {
            this.categories = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            for (var i = 0; i < response.data.length; i++) {
              this.categories.push({ id: response.data[i].CategoryId, text: response.data[i].Name, display: true })
            }
            this.filterCategories()
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      addPriorityFilterButton(type) {
        var data = "";
        var text = "";
        var abbreviation = null;
        var cssIcon = null;
        var filtertype = null;
        var customstyle = "background-color:rgba(131, 189, 166, 0.8)"
        var color = "rgba(131, 189, 166, 0.8)";

        if (type == 'low') {
          color = "rgba(239, 193, 101, 0.8)",
            filtertype = "priority"
          data = 0;
          text = this.$t('priority_low');
          customstyle = "background-color:rgba(239, 193, 101, 0.8)";
          cssIcon = "icon-stack-star icon-2x";
        }
        else if (type == 'medium') {
          color = "rgba(239, 193, 101, 0.8)",
            filtertype = "priority"
          data = 1;
          text = this.$t('priority_medium');
          customstyle = "background-color:rgba(239, 193, 101, 0.8)",
            cssIcon = "icon-stack-check icon-2x";
        }
        else if (type == 'high') {
          color = "rgba(235, 90, 70, 0.8)",
            filtertype = "priority"
          data = 2;
          text = this.$t('priority_high');
          customstyle = "background-color:rgba(235, 90, 70, 0.8)";
          cssIcon = "icon-stack-cancel icon-2x";
        }
        var buttonData =
        {
          color: color,
          customstyle: customstyle,
          customclass: "",
          abbreviation: abbreviation,
          data: data,
          text: text,
          icon: null,
          cssIcon: cssIcon,
          key: type,
          parentguid: null,
          guid:null,
        };

        this.addButton(filtertype, buttonData);

      },
      addShiftButton(type, data, text, shiftTypeId) {

        var customstyle = "background-color:#BC938B"
        var icon = "/images/shifttypes/icon_" + shiftTypeId + "_inverted_no_border_large.png";

        var buttonData =
        {
          color: "#BC938B",
          customstyle: customstyle,
          customclass: "",
          abbreviation: "",
          data: data,
          text: text,
          icon: icon,
          cssIcon: null,
          key: type,
          parentguid: null,
          guid: null,
        };

        this.addButton(type, buttonData);

      },
      addStatusFilterButton(type) {
        var data = "";
        var text = "";
        var abbreviation = null;
        var cssIcon = null;
        var filtertype = null;
        var customstyle = "background-color:rgba(131,189,166,0.8)"
        var color = "rgba(131, 189, 166, 0.8)"
        if (type == 'created') {
          color = "rgba(239, 193, 101, 0.8)";
          filtertype = "status"
          data = 0;
          text = this.$t('created');
          customstyle = "background-color:rgba(239, 193, 101, 0.8)";
          cssIcon = "icon-stack-star icon-2x";
        }
        else if (type == 'lessreadythan') {
          color = "rgba(131,189,166,0.8)";
          filtertype = "lessreadythan"
          data = 100;
          text = this.$t('lessreadythan');
          customstyle = "background-color:rgba(131,189,166,0.8)",
            cssIcon = "icon-stack-check icon-2x";
        }
        else if (type == 'done') {
          color = "rgba(131,189,166,0.8)";
          filtertype = "status"
          data = 2;
          text = this.$t('done');
          customstyle = "background-color:rgba(131,189,166,0.8)",
            cssIcon = "icon-stack-check icon-2x";
        }
        else if (type == 'notstatus') {
          color = "rgba(237,125,49,0.8)";
          filtertype = "notstatus"
          data = 2;
          text = this.$t('not_done');
          customstyle = "background-color:rgba(237,125,49,0.8)";
          cssIcon = "icon-stack-cancel icon-2x";
        }
        else if (type == 'notime') {
          color = "rgba(237,125,49,0.8)";
          filtertype = "status"
          data = 20;
          text = this.$t('status_notime');
          customstyle = "background-color:rgba(237,125,49,0.8)";
          cssIcon = "icon-stack-cancel icon-2x";
        }
        else if (type == 'notable') {
          color = "rgba(237,125,49,0.8)";
          filtertype = "status"
          data = 21;
          text = this.$t('status_notable');
          customstyle = "background-color:rgba(237,125,49,0.8)";
          cssIcon = "icon-stack-cancel icon-2x";
        }
        else if (type == 'missing_information') {
          color = "rgba(237,125,49,0.8)";
          filtertype = "status"
          data = 22;
          text = this.$t('status_missing_information');
          customstyle = "background-color:rgba(237,125,49,0.8)";
          cssIcon = "icon-stack-cancel icon-2x";
        }
        else if (type == 'closed') {
          color = "rgba(255,0,0,0.8)";
          filtertype = "status"
          data = 4;
          text = this.$t('closed');
          customstyle = "background-color:rgba(255,0,0,0.8)",
            cssIcon = "icon-stack-check icon-2x";
        }
        var buttonData =
        {
          color: color,
          customstyle: customstyle,
          customclass: "",
          abbreviation: abbreviation,
          data: data,
          text: text,
          icon: null,
          cssIcon: cssIcon,
          key: type,
          parentguid: null,
          guid: null,
        };

        this.addButton(filtertype, buttonData);

      },

      addDateFilterButton(type) {
        var data = "";
        var startDate = null;
        var endDate = null;
        var text = "";
        var abbreviation = "";
        var cssIcon = null;

        if (type == 'today') {
          startDate = moment();//.add(-1, 'days');
          endDate = moment();
          //abbreviation = endDate.format('D');
          text = this.$t('today');
        }
        else if (type == 'yesterday') {
          startDate = moment().subtract(1, 'days').endOf('day');//moment().endOf('day');
          endDate = moment().subtract(1, 'days').endOf('day');
          //abbreviation = endDate.format('D');
          text = this.$t('yesterday');
        }
        else if (type == 'tomorrow') {
          startDate = moment().add(1, 'days').endOf('day');//moment().endOf('day');
          endDate = moment().add(1, 'days').endOf('day');
          //abbreviation = endDate.format('D');
          text = this.$t('tomorrow');
        }
        else if (type == 'lastweek') {
          startDate = moment().subtract(1, 'weeks').startOf('week');
          endDate = moment().subtract(1, 'weeks').endOf('week');
          abbreviation = null;
          //text = startDate.format('D') + " " + startDate.format('MMM') + "-" + endDate.format('D') + " " + endDate.format('MMM');
          text = this.$t('lastweek')
          cssIcon = "icon-calendar2 icon-2x"
        }
        else if (type == 'last7days') {
          startDate = moment().subtract(7, 'days').endOf('day');
          endDate = moment().subtract(1, 'days').endOf('day');
          abbreviation = null;
          text = this.$t('last7days')
          cssIcon = "icon-calendar2 icon-2x"
        }
        else if (type == 'thisweek') {
          startDate = moment().startOf('week');
          endDate = moment().endOf('week');
          abbreviation = null;
          //text = startDate.format('D') + " " + startDate.format('MMM') + "-" + endDate.format('D') + " " + endDate.format('MMM');
          text = this.$t('thisweek')
          cssIcon = "icon-calendar2 icon-2x"
        }
        else if (type == 'nextweek') {
          startDate = moment().add(1, 'weeks').startOf('week');
          endDate = moment().add(1, 'weeks').endOf('week');
          abbreviation = null;
          text = this.$t('nextweek')
          //text = startDate.format('D') + " " + startDate.format('MMM') + "-" + endDate.format('D') + " " + endDate.format('MMM');
          cssIcon = "icon-calendar2 icon-2x"
        }
        else if (type == 'lastmonth') {
          startDate = moment().subtract(1, 'months').startOf('month');
          endDate = moment().subtract(1, 'months').endOf('month');
          abbreviation = null;
          //text = endDate.format('MMM');
          text = this.$t('lastmonth')
          cssIcon = "icon-calendar2 icon-2x"
        }
        else if (type == 'thismonth') {
          startDate = moment().startOf('month');
          endDate = moment().endOf('month');
          abbreviation = null;
          //text = endDate.format('MMM');
          text = this.$t('thismonth')
          cssIcon = "icon-calendar2 icon-2x"
        }
        else if (type == 'nextmonth') {
          startDate = moment().add(1, 'months').startOf('month');
          endDate = moment().add(1, 'months').endOf('month');
          abbreviation = null;
          //text = endDate.format('MMM');
          text = this.$t('nextmonth')
          cssIcon = "icon-calendar2 icon-2x"
        }
        else if (type == 'anydate') {

          /*
          startDate = moment().add(1, 'months').startOf('month');
          endDate = moment().add(1, 'months').endOf('month');
          abbreviation = null;
          //text = endDate.format('MMM');
          text = this.$t('nextmonth')
          cssIcon = "icon-calendar2 icon-2x"
          */
        }
        else if (type == 'custom') {

        }

        data = startDate.format('YYYY-MM-DD') + "," + endDate.format('YYYY-MM-DD');

        var buttonData =
        {
          color: "rgba(122,176,197,0.8)",
          customstyle: "background-color:rgba(122,176,197,0.8)",
          customclass: "",
          abbreviation: abbreviation,
          data: data,
          text: text,
          icon: null,
          cssIcon: cssIcon,
          key: type,
          parentguid: null,
          guid: null,
        };

        this.addButton('date', buttonData);

      },
      doHideMySchedule() {
        var startDate = moment().startOf('week');;
        var endDate = moment().add(1, 'weeks').endOf('week');

        try {
          this.$http.get('/api/Admin/v1/Users/FutureSchedule?sdate=' + startDate.format('YYYY-MM-DD')
            + "&edate=" + endDate.format('YYYY-MM-DD')).then(async response => {
              var data = response.data;
              if (data != null && data.length > 0) {
                this.hideMySchedule = false;
              } else {
                this.hideMySchedule = true;
                this.$forceUpdate();
              }
            });
        } catch (err) {
          alert('some error:' + err)
        }

      },
      addScheduleFilterButton(type) {
        var startDate = null;
        var endDate = null;
        var cssIcon = null;//"icon-calendar2"
        if (type == 'today') {
          startDate = moment();//.add(-1, 'days');
          endDate = moment();
        }
        else if (type == 'yesterday') {
          startDate = moment().subtract(1, 'days').endOf('day');//.endOf('day');
          endDate = moment().subtract(1, 'days').endOf('day');
        }
        else if (type == 'tomorrow') {
          startDate = moment().add(1, 'days').endOf('day');//.endOf('day');
          endDate = moment().add(1, 'days').endOf('day');
        }
        else if (type == 'thisweek') {
          startDate = moment().startOf('week');
          endDate = moment().endOf('week');
        }
        else if (type == 'nextweek') {
          startDate = moment().add(1, 'weeks').startOf('week');
          endDate = moment().add(1, 'weeks').endOf('week');
        }
        //data = startDate.format('YYYY-MM-DD') + "," + endDate.format('YYYY-MM-DD');
        try {

          this.$http.get('/api/Admin/v1/Users/FutureSchedule?sdate=' + startDate.format('YYYY-MM-DD')
            + "&edate=" + endDate.format('YYYY-MM-DD')).then(async response => {
              var data = response.data;
              if (data != null && data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                  var sch = data[i];
                  var date = moment(sch.Date);
                  var text = date.format('D') + ' ' + date.format('MMM') + ' ' + sch.ShiftTye + '(' + sch.StartTime + '-' + sch.EndTime + ')';
                  var buttonData =
                  {
                    color: "rgba(122,176,197,0.8)",
                    customstyle: "background-color:rgba(122,176,197,0.8)",
                    customclass: "",
                    abbreviation: getAbbreviation(sch.LocationName),
                    //data: sch.Date + ',' + sch.LocationId + ',' + sch.User,
                    data: startDate.format('YYYY-MM-DD') + "," + endDate.format('YYYY-MM-DD') + ',' + sch.LocationId + ',' + sch.SiteShiftId,
                    text: text,
                    icon: null,
                    cssIcon: cssIcon,
                    key: type,
                    parentguid: null,
                    guid: null,
                  };
                  this.addButton('schedule', buttonData);
                }
              }
            });
        } catch (err) {
          alert('some error:' + err)
        }

      },

      addFilterButton(type, data, text, menu) {
        if (type == "report") {
          var url = store.getTodoUrl() + "?reportid=" + data;
          location.href = url;
        } else {
          var bgStyle = "";
          var icon = null;
          var abrText = text + "";
          var color = "";

          if (type == "location") {
            color = "rgba(218,224,215,0.8)";
            bgStyle = "background-color:rgba(218,224,215,0.8)";
            //icon = "/images/filter_icons/icon-location.png";
          }
          else if (type == "shift") {
            color = "rgba(100,224,215,0.8)";
            bgStyle = "background-color:rgba(100,224,215,0.8)";
            //icon = "/images/filter_icons/icon-location.png";
          }
          else if (type == "user") {
            color = "rgba(239,193,101,0.8)";
            bgStyle = "background-color:rgba(239,193,101,0.8)";
            //menu = [{ text: 'User location', command: 'allusers' }, { text: 'User task status', command: 'usertaskstatus' }, { text: 'User time done', command: 'usertime' }]
          }
          else if (type == "team") {
            // alert("data:" + data)
            color = "rgba(200,228,143,0.8)";
            bgStyle = "background-color:rgba(200,228,143,0.8)";
            //menu = [{ text: 'All team users', command: 'allusers' }, { text: 'Team task status', command: 'teamtaskstatus' }, { text: 'Team work load', command: 'teamworkload' }, { text: 'Team time done', command: 'teamtime' }, { text: 'Manage users', command: 'manageteam' },]
          }
          else if (type == "project") {            
            color = "rgba(200,228,143,0.8)";
            bgStyle = "background-color:rgb(16 132 225)";
          }
          else if (type == "status") {
            color = "rgba(131,189,166,0.8)";
            bgStyle = "background-color:rgba(131,189,166,0.8)";
          }
          else if (type == "priority") {
            color = "rgba(173,207,220,0.8)";
            bgStyle = "background-color:rgba(173,207,220,0.8)";
            //icon = "/images/filter_icons/icon-priority.png";
          }
          else if (type == "date") {
            color = "rgba(122,176,197,0.8)";
            bgStyle = "background-color:rgba(122,176,197,0.8)";
          }
          else if (type == "contact") {
            color = "rgba(18,174,245,0.8)";
            bgStyle = "background-color:rgba(18,174,245,0.8)";
          }
          else if (type == "organisation") {
            color = "rgba(142,157,178,0.8)";
            bgStyle = "background-color:rgba(142,157,178,0.8)";
            //icon = "/images/filter_icons/icon-location.png";
          }
          else if (type == "procedure") {
            color = "rgba(248,220,211,0.8)";
            bgStyle = "background-color:rgba(248,220,211,0.8)";
            //icon = "/images/filter_icons/icon-location.png";
          }
          else if (type == "category") {
            color = "rgba(188,147,139,0.8)";
            bgStyle = "background-color:rgba(188,147,139,0.8)";
            //icon = "/images/filter_icons/icon-location.png";
          }
          else if (type == "tag") {
            color = "rgba(142,157,178,0.8)";
            bgStyle = "background-color:rgba(142,157,178,0.8)";
            //icon = "/images/filter_icons/icon-location.png";
          }
          else if (type == "siteshift") {
            color = "rgba(131, 189, 166, 0.8)";
            bgStyle = "background-color:rgba(131, 189, 166, 0.8)";
            abrText = null;
          }
          var buttonData =
          {
            color: color,
            customstyle: bgStyle,
            customclass: "",
            abbreviation: getAbbreviation(abrText),
            data: data,
            icon: icon,
            text: getShortName(text),
            menu: menu,
            key: type,
            parentguid: null,
            guid: null,
          };
          this.addButton(type, buttonData);
        }
      },
      //GetShortName(longname) {
      //  var tmpName = "";
      //  var nameArr = longname.split(' ');
      //  tmpName = nameArr[0];
      //  for (var i = 1; i < nameArr.length; i++) {
      //    tmpName += " " + nameArr[i].substring(0, 1) + ".";
      //  }
      //  //tmpName = tmpName.toUpperCase();
      //  return tmpName;
      //},
      //GetAbbreviation(longname) {
      //  var nameArr = longname.split(' ');
      //  var abbreviation = "";
      //  for (var i = 0; i < nameArr.length; i++) {
      //    abbreviation += nameArr[i].substring(0, 1);
      //  }
      //  abbreviation = abbreviation.toUpperCase();
      //  return abbreviation;
      //},
      filterReports() {
        var visibleItems = 0;
        for (var i = 0; i < this.reports.length; i++) {
          if ((this.reportFilter != null && this.reportFilter != "" && this.reports[i].text.toLowerCase().indexOf(this.reportFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.reports[i].display = false;
          }
          else {
            this.reports[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "reports", this.reports);
      },
      filterLocations() {
        var visibleItems = 0;
        for (var i = 0; i < this.locations.length; i++) {
          if ((this.locationFilter != null && this.locationFilter != "" && this.locations[i].text.toLowerCase().indexOf(this.locationFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.locations[i].display = false;
          }
          else {
            this.locations[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "locations", this.locations);
      },
      filterShifts() {
        var visibleItems = 0;
        for (var i = 0; i < this.shifts.length; i++) {
          if ((this.shiftFilter != null && this.shiftFilter != "" && this.shifts[i].text.toLowerCase().indexOf(this.shiftFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.shifts[i].display = false;
          }
          else {
            this.shifts[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "shifts", this.shifts);
      },
      filterProjects() {
        var visibleItems = 0;
        for (var i = 0; i < this.projects.length; i++) {
          if ((this.projectFilter != null && this.projectFilter != "" && this.projects[i].text.toLowerCase().indexOf(this.projectFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.projects[i].display = false;
          }
          else {
            this.projects[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "projects", this.projects);
      },
      filterTags() {
        var visibleItems = 0;
        for (var i = 0; i < this.tags.length; i++) {
          if ((this.tagFilter != null && this.tagFilter != "" && this.tags[i].text.toLowerCase().indexOf(this.tagFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.tags[i].display = false;
          }
          else {
            this.tags[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "tags", this.tags);
      },
      filterProcedures() {
        var visibleItems = 0;
        for (var i = 0; i < this.procedures.length; i++) {
          if ((this.procedureFilter != null && this.procedureFilter != "" && this.procedures[i].text.toLowerCase().indexOf(this.procedureFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.procedures[i].display = false;
          }
          else {
            this.procedures[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "procedures", this.procedures);
      },
      filterCategories() {
        var visibleItems = 0;
        for (var i = 0; i < this.categories.length; i++) {
          if ((this.categoryFilter != null && this.categoryFilter != "" && this.categories[i].text.toLowerCase().indexOf(this.categoryFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.categories[i].display = false;
          }
          else {
            this.categories[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "categories", this.categories);
      },

      filterUsers() {
        var visibleItems = 0;
        for (var i = 0; i < this.users.length; i++) {
          if ((this.userFilter != null && this.userFilter != ""
            && this.users[i].text.toLowerCase().indexOf(this.userFilter.toLowerCase()) == -1
            && this.users[i].id.toLowerCase().indexOf(this.userFilter.toLowerCase()) == -1
            && this.users[i].email.toLowerCase().indexOf(this.userFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.users[i].display = false;
          }
          else {
            this.users[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "users", this.users);
      },
      filterTeams() {
        var visibleItems = 0;
        for (var i = 0; i < this.teams.length; i++) {
          if ((this.teamFilter != null && this.teamFilter != "" && this.teams[i].text.toLowerCase().indexOf(this.teamFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.teams[i].display = false;
          }
          else {
            this.teams[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "teams", this.teams);
      },
      filterOrganisations() {
        var visibleItems = 0;
        for (var i = 0; i < this.organisations.length; i++) {
          if ((this.organisationFilter != null && this.organisationFilter != "" && this.organisations[i].text.toLowerCase().indexOf(this.organisationFilter.toLowerCase()) == -1) || visibleItems > this.defaultdisplay) {
            this.organisations[i].display = false;
          }
          else {
            this.organisations[i].display = true;
            visibleItems++;
          }
        }
        Vue.set(this, "organisations", this.organisations);
      },

      getdisplay(item) {
        if (item.display == true) {
          return "display:block";
        }
        return "display:none;"
      },
      async loadTeamUsers(team) {
        try {

          this.$http.get('/api/Team/v1/Members/ByName?name=' + team).then(async response => {
            for (var i = 0; i < response.data.length; i++) {
              var member = response.data[i];
              this.addFilterButton('user', member.Name, member.FullName);
            }
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
    },
    computed: {

    },
    mounted() {
      this.$on('remove', function (id) {
        var child = document.getElementById(id);
        child.remove();
      });

    },

    created: function () {

    },

    watch: {

    },
    created() {
      //this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>

<style scoped>



  .filter-badge {
    line-height: 10px;
  }

  .filter-badge {
    position: absolute;
    top: -5px;
    right: 0px;
  }

  .newplus-button {
    color: #666;
    background-color: white !important;
    margin-top: 16px;
    margin-left: 5px;
  }

    .newplus-button img {
      width: 45px;
      height: 45px;
      margin-top: 5px;
    }

  .button-icon {
    width: 45px;
    height: 45px;
  }



  .btn-outline:not(.disabled):not(:disabled):not([class*="alpha-"]):hover, .newplus-button i:hover, .newplus-button i:active, .newplus-button i:focus {
    color: #000 !important;
  }

  .mobile-submenu {
    left: 0px !important;
  }

  @media (min-width: 768px) {

    .button-icon {
      width: 80px;
      height: 80px;
    }

    .mobile-submenu {
      left: 100% !important;
      position: absolute !important;
    }


    .newplus-button {
      border-color: white !important;
      background-color: white !important;
      margin-left: 17px;
      margin-top: -4px !important;
    }
  }

  .expanded-container-collapsed {
    opacity: 0;
    width: 0px;
    height: 0px;
  }

  .expanded-container-active {
    opacity: 1;
    width: 100%;
    height: 200px;
    background-color: green;
    transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
    -webkit-transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
    -moz-transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
    -o-transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
    transition: width 1s ease-out, height 1s ease-out, opacity 1s ease-out;
  }

  /*
  .childComponentContainer .configurator {
    margin-left: 15px !important;
  }

  .childComponentContainer .configurator:nth-child(0) {
    margin-left: 0px !important;
  }
  */
  @media screen and (max-width:768px) {

    .newplus-button img {
      width: 46px;
      height: 46px;
      margin-top: 10px;
      margin-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/filter/filter-container.vue